import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

export const shouldEnableDatadogRum = () =>
  typeof window !== "undefined" &&
  process.env.NEXT_PUBLIC_ENABLE_DATADOG_RUM === "1" &&
  process.env.NODE_ENV === "production";

export const initDatadogRum = () => {
  if (!shouldEnableDatadogRum()) {
    console.log("Skipping DD initialization...");
    return;
  }

  console.log("Initializing DD...");

  try {
    datadogRum.init({
      applicationId: "a05f592b-c626-4b05-b1cd-82b9afc52a3a",
      clientToken: "pub01bc70f8282f1db68a76db020bdb1f2a",
      site: "datadoghq.com",
      service: "member-portal",
      version: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ?? undefined,
      env: process.env.NEXT_PUBLIC_ENVIRONMENT === "prod" ? "prod" : "qa",
      allowedTracingUrls: [/^https:\/\/[^/]+\.treatmyocd\.com/],
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      startSessionReplayRecordingManually: true,
      defaultPrivacyLevel: "allow",
      plugins: [reactPlugin({ router: false })],
    });
  } catch (error) {
    console.error("Error initializing DD:", error);
  }
};
